import React from "react";

export default function GroundVehicleMFS(props) {
  return (
    <div className="groundVehiclePLV">
      <p>
        Dealer is responsible for paying off the vehicle and customer will not
        recieve any lease-end charges.
      </p>
    </div>
  );
}
